import React, { useState } from 'react';
import banner1 from "../../assets/banner/aboutbannerimagenew.jpg";
import banner from "../../assets/banner/construction-site-silhouettes.jpg";
import "./about.css";
import Ourteam from '../ourteam/Ourteam';
import Whychooseus from '../whychoose/Whychoose';
import Visionmission from '../visionmission/Visionmision';
import Nav from '../nav/Nav';
import Popup from '../Popup/Popup';

function Aboutmain() {
  const [showPopup, setShowPopup] = useState(false);

  const handleEnquiryClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <section>
        <div className="image-all-banner">
          <img src={banner1} alt="About Us" className="image-bg-all" />
          <div className="overlay-all-page">
            <h2 className="fade-in-text">About Us</h2>
          </div>
        </div>
      </section>

      <section className='about-section'>
        <div className='container'>
          <div className='row'>
            <div className="col-lg-5">
              <div className="ttm_single_image-wrapper after-border style2 position-relative ml-20">
                <img className="img-fluid border-12px-solid white-border" src={banner} alt="About Banner" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="spacing-1 ttm-bgcolor-white bordertop-12px-solid skincolor-border">
                <div className="section-title clearfix">
                  <div className="title-header">
                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>About</h5>
                    <h3>New Sky Property & Projects Private Limited (NSPP)</h3>
                  </div>
                  <div className='underline'></div>
                </div>
                <p className='p-para'>
                  New Sky Property & Projects Private Limited (NSPP), based in Chennai, Tamil Nadu, is a professionally managed company offering comprehensive solutions in construction and real estate. Backed by experienced directors and a strong leadership team, we specialize in handling large-scale projects, residential layouts,
                  and property transactions with precision and integrity.                </p>
                <p className='p-para'>

                  Our directors bring strong leadership, deep industry knowledge, and practical project experience that guide our company’s growth and reputation.
                  Our Strength: Expert Team & Legal Support At NSPP, we are proud to have a highly skilled team of real estate professionals, engineers, architects, and dedicated project managers who ensure every project
                  is executed with quality, precision, and on-time delivery.                </p>
              </div>
            </div>
          </div>
          <p className='p-para'>
            We also work closely with top legal experts and senior advocates who specialize in property law. Our legal team has successfully handled many property-related cases, documentation clearances, and land dispute resolutions, ensuring all our projects and
            client dealings are legally strong and fully secured.
          </p>
          <p className='p-para'>
            Whether you are buying, selling, developing, or managing property, NSPP provides a seamless experience with full responsibility and care. Our mission is to build lasting relationships with every client by offering secure, quality-driven,
            and trustworthy real estate services.
          </p>
           <div className="d-flex justify-content-center mb-3">
                  <button className="btn get-button get-align"  onClick={handleEnquiryClick}>
                    Get Enquiry
                  </button>
                </div>
        </div>
      </section>

      <Visionmission />
      <Ourteam />
      <Whychooseus />

      <Popup show={showPopup} onClose={handleClosePopup} />
    </>
  );
}

export default Aboutmain;
